import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

const markerOptions = {
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
};

// Leaflet cannot reliably detect its image directory after Webpack fingerprints
// the assets. Configure the bundled URLs once, before any map is rendered.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions(markerOptions);

const defaultLeafletMarkerIcon = L.icon(markerOptions);

// Also protect markers created by Leaflet plugins without an explicit icon.
L.Marker.mergeOptions({ icon: defaultLeafletMarkerIcon });

export default defaultLeafletMarkerIcon;
